export default __webpack_public_path__ + "static/media/snow-land.789b93ec.png";